function Intro() {
  return <div>Intro</div>
}

export default Intro
